import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // useNavigate로 변경
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const AsobiApp = () => {
  const location = useLocation();
  const navigate = useNavigate(); // useNavigate 사용
  const appDownRef = useRef(null);

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | APP`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출
  }, [location, navigate]); // navigate 추가

  // 스크롤 핸들러
  const scrollToAppDown = () => {
    appDownRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Header />
      <ScrollAnimation />
      <section id="container">
        <div className="app">
          <div className="sect app01">
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_app_app01_img_2023.png"
                  alt="앱 화면 이미지"
                />
              </div>
              <div className="con">
                <div className="txt init">우리 아이 학습 관리를 한 눈에! </div>
                <div className="title-wrap">
                  <div className="tit init">아소비 APP</div>
                  <div className="button-wrap">
                    <div className="act init">
                      <span className="down">
                        <a onClick={scrollToAppDown}>다운로드</a>
                      </span>
                    </div>
                    <div className="act init">
                      <a
                        href="../DATA/upload/아소비앱_매뉴얼.pdf"
                        target="_blank"
                      >
                        매뉴얼 다운로드
                      </a>
                    </div>
                  </div>
                </div>
                {/* < div className="ico"><img src="../custom-resources/img/img_app_app01_eye.png" alt=""/></div>    */}
              </div>
            </div>
          </div>
          <div className="sect app02">
            <div className="wrap">
              <div className="img init">
                <img src="../custom-resources/img/img_app_app02.png" alt="" />
                <i>
                  <img
                    src="../custom-resources/img/img_app_app02_p01_2023.png"
                    alt=""
                  />
                </i>
                <i>
                  <img
                    src="../custom-resources/img/img_app_app02_p02_2023.png"
                    alt=""
                  />
                </i>
                <i>
                  <img
                    src="../custom-resources/img/img_app_app02_p03_2023.png"
                    alt=""
                  />
                </i>
                <i>
                  <img
                    src="../custom-resources/img/img_app_app02_p04_2023.png"
                    alt=""
                  />
                </i>
                <i>
                  <img
                    src="../custom-resources/img/img_app_app02_p05_2023.png"
                    alt=""
                  />
                </i>
                <i>
                  <img
                    src="../custom-resources/img/img_app_app02_p06_2023.png"
                    alt=""
                  />
                </i>
              </div>
              <div className="con">
                <div className="tit init">
                  아소비 APP
                  <br /> <span>이렇게 활용하세요!</span>
                </div>
                <div className="txt init">
                  <p>
                    아소비 <span>회원만 사용 가능한 무료</span> 어플리케이션
                  </p>
                  <p>
                    댓글 기능을 통한 <span>양방향 소통</span>
                  </p>
                  <p>
                    등원/하원 PUSH알림
                    <span>으로 우리아이 등하원 현황 확인</span>
                  </p>
                  <p>
                    다양한 <span>교육정보/이벤트</span> 확인 가능
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="sect app03">
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_app_app03_img_2023.png"
                  alt=""
                  className="pc-view"
                />
                <img
                  src="../custom-resources/img/img_app_app03_img_mo_2023.png"
                  alt=""
                  className="mo-view"
                />
              </div>
              <div className="con">
                <div className="tit init">
                  한눈에 알아보는 <br />
                  <span>학습 진행 현황</span>
                </div>
                <div className="txt init">
                  알림장 기능에서는 <br />
                  오늘의 학습부터 이달의 학습 내용, <br />
                  다음 달의 진도까지 파악해 <br />
                  아이 학습을 <span>체계적으로 관리</span>할 수 있어요!
                </div>
                <div className="ico init">
                  <i>
                    <img
                      src="../custom-resources/img/img_app_app03_eye.png"
                      alt=""
                      className=" moveimg"
                    />
                  </i>
                  <img
                    src="../custom-resources/img/img_app_app03_eye_after.png"
                    alt=""
                    className="animg"
                  />
                  <img
                    src="../custom-resources/img/img_app_app03_eye_after2.png"
                    alt=""
                    className="animg"
                  />
                  <img
                    src="../custom-resources/img/img_app_app03_eye_after3.png"
                    alt=""
                    className="animg"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sect app04">
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_app_app04_img_2023.png"
                  alt=""
                  className="pc-view"
                />
                <img
                  src="../custom-resources/img/img_app_app04_img_mo_2023.png"
                  alt=""
                  className="mo-view"
                />
              </div>
              <div className="con">
                <div className="tit init">
                  <span>교육원에서의 모습</span>이 <br />
                  궁금하다면 <span>앨범</span>으로
                </div>
                <div className="txt init">
                  앨범 기능에서는 <br />
                  우리 아이가 공부하는 모습, <br />
                  친구들과 함께 어울리는 모습 등 <br />
                  아이가 <span>어떻게 활동하는 확인</span>할 수 있어요!
                </div>
                <div className="ico init">
                  <img src="../custom-resources/img/img_app_app04_eye.png" alt="" />
                  <img src="../custom-resources/img/img_app_app04_eye2.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sect app05">
            <div className="bg">
              <i className="pc-view">
                <img src="../custom-resources/img/img_app_app05_2023.png" alt="" />
              </i>
              <i className="pc-view">
                <img src="../custom-resources/img/img_app_app05_2_2023.png" alt="" />
              </i>
              <i className="mo-view">
                <img
                  src="../custom-resources/img/img_app_app05_01_mo_2023.png"
                  alt=""
                />
              </i>
              <i className="mo-view">
                <img
                  src="../custom-resources/img/img_app_app05_02_mo_2023.png"
                  alt=""
                />
              </i>
            </div>
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_app_app05_img_2023.png"
                  alt=""
                  className="pc-view"
                />
                <img
                  src="../custom-resources/img/img_app_app05_img_mo_2023.png"
                  alt=""
                  className="mo-view"
                />
              </div>
              <div className="con">
                <div className="tit init">
                  공식적인
                  <br />
                  <span>아소비 소식</span>
                </div>
                <div className="txt init">
                  공지사항 기능에서는 <br />
                  아이가 다니고 있는 <span>교육원의 소식</span>을 <br />
                  놓치지 않고 확인할 수 있어요!
                </div>
                <div className="ico init">
                  <img
                    src="../custom-resources/img/img_app_app05_eye_2023.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sect app06">
            <div className="wrap">
              <div className="img">
                <img src="../custom-resources/img/img_app_app06_img_2023.png" alt="" />
              </div>
              <div className="con">
                <div className="tit init">
                  <div className="tag">
                    <img
                      src="../custom-resources/img/img_app_app06_tag_2023.png"
                      alt=""
                    />
                  </div>
                  우리 아이 <span>출석 현황을</span>
                  <br />
                  실시간으로
                </div>
                <div className="txt init">
                  출석부 기능에서는 <br />
                  우리 아이 교육원 <span>등/하원 현황</span>과 <br />
                  <span>일자별 게시글</span>을 쉽게 확인할 수 있어요!{" "}
                </div>
                <div className="lst init">
                  <p>해당 달 출석 일수가 한눈에 표시되어요!</p>
                  <p>
                    <span className="ball green">등원</span>{" "}
                    <span className="ball red">하원</span> 현황을 확인할 수
                    있어요!
                  </p>
                  <p>
                    가정통신문/알림장/앨범/공지사항을 클릭해
                    <br />
                    내용을 확인할 수 있어요!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="sect app07">
            <div className="bg">
              <i className="pc-view">
                <img src="../custom-resources/img/img_app_app05_02.png" alt="" />
              </i>
              <i className="mo-view">
                <img
                  src="../custom-resources/img/img_app_app07_02_mo_2023.png"
                  alt=""
                />
              </i>
            </div>
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_app_app07_img_2023.png"
                  alt=""
                  className="pc-view"
                />
                <img
                  src="../custom-resources/img/img_app_app07_03_mo_2023.png"
                  alt=""
                  className="mo-view"
                />
              </div>
              <div className="con">
                <div className="tit init">
                  <div className="tag">
                    <img
                      src="../custom-resources/img/img_app_app07_tag_2023.png"
                      alt=""
                    />
                  </div>
                  다양하고 유익한
                  <br />
                  <span>교육정보와 이벤트!</span>
                </div>
                <div className="txt init">
                  공지사항 기능에서 나아가
                  <br />
                  다양하고 유익한 <span>교육 정보</span>와 <span>이벤트</span>를{" "}
                  <br />
                  공유하는 공간이 새롭게 생겼어요.
                  <br />
                  아소비 앱을 통해 그 혜택을 누리세요!
                </div>
                <div className="ico init">
                  <img src="../custom-resources/img/img_app_app05_eye.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sect app08" id="appdown" ref={appDownRef}>
            <div className="wrap">
              <div className="vod">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/a0DhNoNAwdM?si=U0jO1BxW6O6wIke0"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="tit">
                <span>아소비 APP</span> 다운받기
              </div>
              <div className="txt">
                언제 어디서든 편리하게 아이 학습 현황을 확인하고 <br />
                원장님과 소통할 수 있는 <span>아소비앱</span>을 확용하세요!{" "}
              </div>
              <div className="act">
                <a href="https://bit.ly/3sPALYP">
                  <div className="google">
                    <i></i> <p>Google Play</p>
                  </div>
                  <div className="hover">다운로드</div>
                </a>
                <a href="https://apple.co/3N4DNz4">
                  <div className="apple">
                    <i></i> <p>App Store</p>
                  </div>
                  <div className="hover">다운로드</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AsobiApp;
